import React, { useEffect, useMemo, useState } from "react";
import { AccordionList } from "Components/Accordion";
import { Container } from "Components/ReactstrapSlim";
import { ConfigClient } from "Services/API/API";
import { replaceVariables } from "./helpers";

import classes from "./FAQSection.module.scss";

import FREQUENTLY_ASKED_QUESTIONS from "../../../data/FREQUENTLY_ASKED_QUESTIONS.json";

const DEFAULT_DATA = {
   citiesCounting: 2700,
   verifiedVenuePartners: 10500,
};

const FAQSection: React.FC = () => {
   const [data, setData] = useState(DEFAULT_DATA);

   const questionsAndAnswers = useMemo(() => {
      return FREQUENTLY_ASKED_QUESTIONS.map((item) => ({
         ...item,
         description: replaceVariables(item.description, data),
      }));
   }, [data]);

   useEffect(() => {
      const fetchData = async () => {
         const configClient = new ConfigClient();
         const stats = await configClient.getMarketingStats();
         setData(stats);
      };

      fetchData();
   }, []);

   return (
      <section id="faq" className={classes.section}>
         <Container>
            <div className={classes.container}>
               <div className={classes.caption}>
                  <div className={classes.captionTitle}>
                     Frequently Asked Questions
                  </div>
                  <div className={classes.captionSubtitle}>
                     Let&rsquo;s answer those questions.
                     <br />
                     (We know you have some.)
                  </div>
               </div>
               <div className={classes.content}>
                  <AccordionList items={questionsAndAnswers} />
               </div>
            </div>
         </Container>
      </section>
   );
};

export default FAQSection;
